import { Component } from '@angular/core';

@Component({
  templateUrl: './finish-account.page.html',
})
/**
 * Finish Account Page
 */
export class FinishAccountPage {}
